export const FM_DD_MM_YYY_HH_MM = "dd/MM/yyyy HH:mm";
export const FM_DD_MM_YYY_HH_MM_DAY_JS = "YYYY-MM-DDTHH:mm";
export const FM_HH_DD_MM_YY = "hh:mm dd/mm/yyyy";
export const FM_DD_MM = "dd/MM";
export const FM_DD_MM_YYYY = "dd/MM/yyyy";
export const FM_MM_YYYY = "MM/yyyy";

export const FM_SHARING_PROFILE =
  "Họ và tên: {name}\nEmail: {email}\nVai trò: {role}\nPhòng ban: {department}\nSố điện thoại: {phone}";
